<template>
  <div class="props-group">
      <!-- <el-form-item label="列数">
        <el-input-number v-model="component.properties.numberOfColumns" :controls="false"  :min="1" max="20"/>
      </el-form-item> -->
      <el-form-item label="行数">
        <el-input-number v-model="component.properties.numberOfLines" :min="1" max="20" />
      </el-form-item>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'attr-row-col',
  props: ['component'],
  methods: {
    saveAttr () {
      // 删除改变行列之后多余的控件
      let component = this.component
      _.remove(component.children, m => {
        return (parseInt(m.position.col) > parseInt(component.properties.numberOfColumns) || parseInt(m.position.row) > parseInt(component.properties.numberOfLines))
      })
      component.position.sizey = component.properties.numberOfLines
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/form/componentAttr/row-col.vue